<!-- TODO: Add #CMS Translations -->
<div class="h-full flex flex-col">
    <div class="mt-2h flex flex-col gap-2 pb-10">
        <p class="text-2xl/7 font-bold text-[#333333]">Enter security code</p>
        <p class="text-base text-[#737373]">We sent a security code to {{ displayPhoneNumber }}</p>
    </div>
    <div class="flex flex-col items-start">
        <p class="text-xs text-[#737373]">Code will be valid for 15 minutes.</p>
         <app-otp-input #otpInputComponent (otpFormSubmitEvent)="submitOtp($event)" class="mt-4 mb-6 w-full" [size]='6'></app-otp-input>
        <button [disabled]="isResetButtonDisabled" (click)="requestNewOtpCode()" class="text-[#e42313] font-['Roboto'] font-bold border-none bg-white" [ngClass]="{'text-gray-500': isResetButtonDisabled}">Send a new code</button>
        <app-countdown-timer [timerClickSubject]="timerClickSubject" [initialTime]="initialCountdownInSeconds"></app-countdown-timer>
    </div>
</div>
